import {z} from 'zod';

export const SelectableMaterialItemDetailFormSchema = z.object({
  generalInformation: z.object({
    integrationId: z.string(),
    authorizationProfileIds: z.array(z.string()).nullish(),
  }),
  externalSundry: z.object({
    code: z.string(),
    name: z.string().nullish(),
    type: z.string().nullish(),
    specification: z.string().nullish(),
    unit: z.string().nullish(),
  }),
  warehouseArticleId: z.string().nullish(),
});

export type SelectableMaterialItemDetailForm = z.infer<
  typeof SelectableMaterialItemDetailFormSchema
>;
